import { Component, Input } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Manages a confirmation dialog
 */
@Component({
    selector: 'app-too-much-sites-dialog',
    templateUrl: './too-much-sites-dialog.component.html',
    styleUrls: ['./too-much-sites-dialog.component.scss'],
    standalone: true,
    imports: [
        NbCardModule,
        NbButtonModule,
        TranslateModule,
    ],
})
export class TooMuchSitesDialogComponent {

  /**
   * title of the dialog box
   */
  @Input() public label: string;
  /**
   * The maximum number of sites selected
   */
  @Input() public sitesLimit: number;

  constructor(
    private ref: NbDialogRef<TooMuchSitesDialogComponent>,
  ) {
  }

  public confirm(): void {
    this.ref.close();
  }

  public close(): void {
    this.ref.close();
  }

}
